import {MessageInstance} from "antd/lib/message";

import {RootState as RS} from "../app/store";
import { Creation } from '../utils-creation/types';

export type RootState=RS;

export enum SearchTab {
    RESEARCHERS = 'researchers',
    PUBLICATIONS = 'publications',
    GS_PUBLICATIONS = 'gs-publications',
    SMT_PUBLICATIONS = 'smt-publications',
    TRENDING = 'trending',
    RESEARCH_CREATION = 'research-creation',
}

export type statusType = 'idle'|'loading'|'succeeded'|'failed';
export type errorMsgType = string|null|undefined;

export type searchInput = string;
export type keywordType = 'search' | 'match';
export type pubListSortType = '-date' | '-cited_by_count' | '-altmetric_score' | '-rank';
export type gsPubListSortType = 'year' | '-year' | 'citationCount' | '-citationCount';
// export type gsPubListSortType = 
//     '-date' | 'title' | '-cited_by_count' | '-altmetric_score' | '-rank';
export type altTrendingSortType = 
    '-altmetric_score' | 
    '-historical_mentions_1d' |
    '-historical_mentions_1m' |
    '-historical_mentions_1w' |
    '-historical_mentions_1y' |
    '-historical_mentions_3d' |
    '-historical_mentions_3m' |
    '-historical_mentions_6m' |
    '-historical_mentions_at';
export type rsrListSortType = '-date';
export type requestIdType = string|null;

export interface DeptI {
  id: number;
  name: string;
  short: string;
  faculty: number;
  link: string;
}
export interface FcltDeptI {
  id: number;
  name: string;
  department_set: DeptI[];
  link: string;
}

export interface DeptDicI {
  [id: number]:{
    name: string;
    short: string;
    facultyID: number;
    link: string;
  }
}
export interface FcltDicI {
  [id: number]:{
    name: string;
    depts: number[];
    link: string;
  }
}
export interface FcltDeptState_static {
    fclts: FcltDicI,
    depts: DeptDicI,
    status: statusType,
    errorMsg: errorMsgType
}
export interface rFcltDeptStat_AltTrending {
    total: number,
    fclts: {id:number, cnt: number}[],
    depts: {id:number, cnt: number}[],
}
export interface FcltDeptStat_Pub {
    total: number,
    fclts: {id:number, cnt: number}[],
    depts: {id:number, cnt: number}[],
}
export interface FcltDeptStat_GsPub {
    total: number,
    fclts: {id:number, cnt: number}[],
    depts: {id:number, cnt: number}[],
}
export interface FcltDeptStat_Rsr {
    total: number,
    fclts: {id:number, cnt: number}[],
    depts: {id:number, cnt: number}[],
}
export interface SelectorOption {
    name: string,
    value: string,
    count?: number
}

export interface StringToStringObject {
    [name: string]: string
}

export interface StringToNumberObject {
    [name: string]: number
}

export interface GsPublication {
    sfu_authors: Researcher[],
    gs_url: string | null,
    title: string | null,
    url: string | null,
    doi: string | null,

    description: string | null,

    authors: string | null,
    inventors: string | null,

    publicationDate: string | null,
    decidedDate: string | null,

    reportNumber: string | null,
    applicationNumber: string | null,
    docketId: string | null,

    patentNumber: string | null,

    conference: string | null,
    journal: string | null,
    book: string | null,

    issue: string | null,
    pages: string | null,
    volumn: string | null,

    source: string | null,
    court: string | null,
    patentOffice: string | null,
    institution: string | null,
    publisher: string | null,

    citationCount: string | null,
    citationUrl: string | null,
}

export interface SmtPublication {
    sfu_authors: Researcher[],
    title: string | null,
    resource_type: string | null,

    date_created: string | null,
    authors: string | null,

    abstract: string | null,
    publication_title: string | null,

    thesis_advisor: string | null,
}

export interface Publication {
    DOI: string | null,
    title: string | null,
    abstract: string | null,
    keywords: string | null,
    all_authors: string | null,
    authorsCnt: number | null,
    sfu_authors: Researcher[],
    date: string | null,
    rank: number | null,
    pubSrcName: string | null,
    pubSrcType: string | null,
}

export interface Researcher {
    random_id: string,
    preferred_first_name: string,
    preferred_last_name: string,
    preferred_email: string | null,
    preferred_pronouns: string | null,
    primary_campus: string | null,
    show_preferred_email: boolean,
    show_preferred_pronouns: boolean,
    show_primary_campus: boolean,
    sfu_link: string | null,
    google_scholar_link: string | null,
    interests: string | null,
    rank: number | null,
    recruitment: Recruitment,
    departments: Department[],
    description: string | null,
    show_description: boolean,
    languages: string[],
    show_languages: boolean,
    C3I: boolean,
    SDGvec: boolean[],
}

export interface Recruitment {
    accepting_graduate_student: boolean,
    note: string,
    years: number[]
}

// Slice state
export interface AppState {
    messageApi: MessageInstance | null
}





export interface SearchPageUserInputs {
    searchInput: searchInput,
    keywordType: keywordType,
    facultyID: number,
    departmentID: number,
    searchTab: SearchTab,
    rsrSpecific:{
        acceptingGraduateStudentChecked: boolean,
        C3IChecked: boolean,
        SDGs: number[]
    },
    pubSpecific:{
        year: number,
        sortType: pubListSortType,
    },
    gsPubSpecific:{
        year: number,
        sortType: gsPubListSortType,
    },
    altTrendingSpecific:{
        sortType: altTrendingSortType,
    },
    creationSpecific: {
        year: number,
        sortType: '-premiere_year',
    },
}
export interface SearchBlockState {
    searchInput_internal: searchInput,
}

export interface RsrFilterState {
    fcltDeptStat: FcltDeptStat_Rsr,
    SDG: {
        statInfo: {statVec:number[], total: number}
        status: statusType, 
        errorMsg?: errorMsgType,
        currentRequestId: requestIdType,
    },
    status: statusType,
    errorMsg: errorMsgType,
    currentRequestId: requestIdType,
}
export interface AltTrendingFilterState {
    fcltDeptStat: rFcltDeptStat_AltTrending,
    status: statusType,
    errorMsg: errorMsgType
    currentRequestId: requestIdType,
}
export interface PubFilterState {
    fcltDeptStat: FcltDeptStat_Pub,
    status: statusType,
    errorMsg: errorMsgType
    currentRequestId: requestIdType,
}

export interface GsPubFilterState {
    fcltDeptStat: FcltDeptStat_Pub,
    status: statusType,
    errorMsg: errorMsgType
    currentRequestId: requestIdType,
}

export interface SmtPubFilterState {
    fcltDeptStat: FcltDeptStat_Pub,
    status: statusType,
    errorMsg: errorMsgType
    currentRequestId: requestIdType,
}

export interface GsPubTab {
    total: number,
    gsPubList: ResultItem[],
    currentPage: number,
    hasNext: boolean,
    status: statusType,
    errorMsg: errorMsgType,
    currentRequestId: requestIdType,
    yearFilter: {
        total: number,
        years: {year:number, cnt:number}[],
        status: statusType,
        errorMsg: errorMsgType,
        currentRequestId: requestIdType,
    },
}

export interface SmtPubTab {
    total: number,
    smtPubList: ResultItem[],
    currentPage: number,
    hasNext: boolean,
    status: statusType,
    errorMsg: errorMsgType,
    currentRequestId: requestIdType,
}

export interface PubTab {
    total: number,
    pubList: ResultItem[],
    currentPage: number,
    hasNext: boolean,
    status: statusType,
    errorMsg: errorMsgType,
    currentRequestId: requestIdType,
    yearFilter: {
        total: number,
        years: {year:number, cnt:number}[],
        status: statusType,
        errorMsg: errorMsgType,
        currentRequestId: requestIdType,
    },
}
export interface RsrTab {
    total: number,
    rsrList: ResultItem[],
    currentPage: number,
    hasNext: boolean,
    status: statusType,
    errorMsg: errorMsgType,
    currentRequestId: requestIdType,
}

export interface AltTrendingItem {
    sfu_authors: {
        random_id: string,
        preferred_first_name: string,
        preferred_last_name: string
    }[],
    altmetric_score: number,
    altmetric_id: string,
    altmetric_url: string,
    title: string,
    doi: string | null,
    publication_date: string,
    journal_title: string,
    historical_mentions_1d: number,
    historical_mentions_1m: number,
    historical_mentions_1w: number,
    historical_mentions_1y: number,
    historical_mentions_3d: number,
    historical_mentions_3m: number,
    historical_mentions_6m: number,
    historical_mentions_at: number,
}

export interface AltTrendingTab {
    pubList: {
        item: AltTrendingItem | null, 
        loading: boolean
    }[],
    currentPage: number,
    hasNext: boolean,
    status: statusType,
    errorMsg: errorMsgType,
    currentRequestId: requestIdType,
}

export interface ProfilePg_ScopusTab {
    total: number,
    pubList: ResultItem[],
    currentPage: number,
    hasNext: boolean,
    status: statusType,
    errorMsg: errorMsgType,
    yearFilter: {
        total: number,
        year: number,
        years: {year:number, cnt:number}[],
        status: statusType,
        errorMsg: errorMsgType,
    },
    sortType: pubListSortType
}

export interface ProfilePg_GsPubTab {
    total: number,
    gsPubList: ResultItem[],
    currentPage: number,
    hasNext: boolean,
    status: statusType,
    errorMsg: errorMsgType,
    yearFilter: {
        total: number,
        year: number,
        years: {year:number, cnt:number}[],
        status: statusType,
        errorMsg: errorMsgType,
    },
    sortType: gsPubListSortType
}

export interface ProfilePg_SmtPubTab {
    total: number,
    smtPubList: ResultItem[],
    currentPage: number,
    hasNext: boolean,
    status: statusType,
    errorMsg: errorMsgType,
}




export interface authenticationState {
    user: UserGETResponse | null,
    nonResearcherSFUComputingID: string | null
}

export interface authenticationErrorState {
    error: string | null,
}

export interface loginControllerState {
    messageVisible: boolean
}

export interface GeneralPanelState {
    generalInfo: GeneralInfoGETResponse,
    loading: boolean,
    error: string | null,
    showSuccess: boolean,
    showFailure: boolean,
}

export interface ProfilePageState {
    researcher: Researcher | null,
    status: statusType,
    errorMsg: errorMsgType,
}

export interface ResultItem {
    item: SmtPublication | GsPublication | Publication | Researcher | Creation | null,
    loading: boolean,
}


// API schema


export interface Department {
    id: string,
    name: string,
    count: number,
    short: string,
    link: string,
    faculty: {
        name: string,
        link: string,
    }
}

export interface Faculty {
    id: string,
    name: string,
    count: number,
    link: string,
    department_set: Department[],
}

// request
export interface SDGStatGETRequest {
    searchInput?: searchInput,
    keywordType?: keywordType,
    deptID?: number,
    fcltID?: number,
    acceptingGraduateStudentChecked?: boolean,
    C3IChecked?: boolean,
    SDG?: number,
}

export interface SDGStatGETResponse {
    statVec: number[],
    total: number,
}

export interface GeneralInfoPATCHRequest {
    preferred_first_name: string,
    preferred_last_name: string,
    preferred_email: string | null,
    preferred_pronouns: string | null,
    primary_campus: string | null,
    show_preferred_email: boolean,
    show_preferred_pronouns: boolean,
    show_primary_campus: boolean,
    languages: string[],
    show_languages: boolean,
    C3I: boolean,
    interests: string,
    sfu_link: string | null,
    description: string,
    show_description: boolean,
    recruitment: Recruitment,
}

// response
export interface UserGETResponse {
    sfu_computing_id: string,
    preferred_first_name: string,
    preferred_last_name: string,
    random_id: string,
    id: number,
    departments: string,
    show_to_public: boolean,
}

export interface Links {
    next: string | null,
    previous: string | null
}

export interface AltTrendingGETResponse {
    links: Links,
    total_result: number,
    response_result: number,
    results: AltTrendingItem[]
}
export interface PublicationsGETResponse {
    links: Links,
    total_result: number,
    response_result: number,
    results: Publication[]
}

export interface GsPublicationsGETResponse {
    links: Links,
    total_result: number,
    response_result: number,
    results: GsPublication[]
}

export interface SmtPublicationsGETResponse {
    links: Links,
    total_result: number,
    response_result: number,
    results: SmtPublication[]
}

export interface PublicationYearsGETResponse {
    total: number,
    years: {year: number, cnt: number}[]
}

export interface GsPublicationYearsGETResponse {
    total: number,
    years: {year: number, cnt: number}[]
}

export interface ResearchersGETResponse {
    links: Links,
    total_result: number,
    response_result: number,
    results: Researcher[],
}

export interface GeneralInfoGETResponse {
    preferred_first_name: string,
    preferred_last_name: string,
    preferred_email: string | null,
    preferred_pronouns: string | null,
    primary_campus: string | null,
    show_preferred_email: boolean,
    show_preferred_pronouns: boolean,
    show_primary_campus: boolean,
    languages: string[],
    show_languages: boolean,
    interests: string,
    sfu_link: string | null,
    description: string,
    show_description: boolean,
    C3I: boolean,
    recruitment: Recruitment,
}


export interface GeneralInfoInputLengths {
    preferred_first_name: number,
    preferred_last_name: number,
    preferred_email: number,
    preferred_pronouns: number,
    note: number,
    interests: number,
    sfu_link: number,
}

export interface SDGPanelState {
    SDGvec: boolean[],
    status: statusType,
    errorMsg: errorMsgType,
}
export interface SDGvecGETResponse {
    SDGvec: boolean[],
}

export interface PayloadWithCallback {
    payload?: any,
    callback?: () => void,
}

export interface GoogleAnalyticsSearchEvent {
    event: 'search',
    ree_search_value: string,
    ree_keyword_type: 'keyword' | 'researcher' | 'n/a',
    ree_faculty: string,
    ree_department: string,
    ree_tab: SearchTab,
    ree_accepting_grad_students: 'yes' | 'no' | 'n/a',
    ree_C3I: 'yes' | 'no' | 'n/a',
    ree_sdg: number[] | 'n/a',
}

// export interface CreationGETResponse {
//     dance?: any[],
//     filmAndVideo?: any[],
//     musicAndSound?: any[],
//     theatre?: any[],
//     visualArt?: any[],
// }

// export interface CreationDance {
//     "Title": string,
//     "URL (if applicable)": string,
//     "Composer/Creator(s)": string,
//     "Choreographer(s)": string,
//     "Performer(s)": string,
//     "Venue": string,
//     "Lighting Design": string,
//     "Costume Design": string,
//     "Stage Manager": string,
//     "Set Design": string,
//     "Sound Design": string,
//     "Projection Design": string,
//     "Projection Engineer": string,
//     "Premiere Date": string,
//     "Location": string,
//     "Credits": string,
//     "Description": string,
//     "id": number,
// }